<p-confirmDialog class="delete_pop_sec" [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<app-spinner></app-spinner>
<div class="row ultratech_sec">
  <div class="col-md-12 col-lg-12">
    <router-outlet></router-outlet>
  </div>
</div>
<p-dialog [(visible)]="openIdleSessionDialog" class="idlesection" [modal]="true" [showHeader]="false" [draggable]="false"
  [styleClass]="'deleteUser-dialog'">
  <div>
    <div style="display: flex;align-items: center;justify-content: space-between;">
      <h4 style="font-size: 20px;font-family: sans-serif;">Idle session detected</h4>
      <!-- <span class="close-circle" (click)="closeDeleteUserDialog()">
        <span class="pi pi-times" style="color: #053C73;"></span>
    </span> -->
    </div>
    <p style="margin-top: 8px;">You will be logged out in {{countdown}} seconds.</p>
    <div style="text-align: center;">
      <button type="button" (click)="endSession()" class="btn-submit1" style="background-color: #f6f6f6;">Logout</button>
      <button type="button" (click)="stayLoggedIn()" class="btn-submit2" style="background-color: #4c2e88;">Stay Logged
        In</button>
    </div>
  </div>
</p-dialog>